export default __webpack_public_path__ + "static/media/aboutBgDec2.df3c3b23.png";